import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

class CheckboxControl extends Component {
	constructor(props) {
		super(props);

		this.changed = this.changed.bind(this);
	}
	changed() {
		this.props.checkedChanged(this.props.fileId, this.checkbox.checked);
	}
	render() {
		return(
			<div>
				<input
					id={this.props.id}
					type="checkbox"
					ref={(input) => { this.checkbox = input; }}
					checked={this.props.isChecked}
					onChange={this.changed}
				/>
				<label className="checkbox" htmlFor={this.props.id}>{this.props.text}</label>
			</div>
		);
	}
}

const mapDispatchToProps = dispatch => {
	return {
		dispatchChange: (handler, fileId, value) => {
			handler(fileId, value, dispatch);
		}
	}
};

const ConnectedCheckboxControl = connect(
	null,
	mapDispatchToProps
)(CheckboxControl);

CheckboxControl.propTypes = {
	fileId: PropTypes.string.isRequired,
	id: PropTypes.string,
	isChecked: PropTypes.bool,
	checkedChanged: PropTypes.func,
	text: PropTypes.string,
	dispatchChange: PropTypes.func,
}

export default ConnectedCheckboxControl;


// WEBPACK FOOTER //
// ./src/components/CheckboxControl.js